import React, {useCallback, useContext, useEffect, useState} from 'react';
import clsx from "clsx";
import {Button, Card, CardActions, CardContent, CardHeader, Tooltip, Typography} from "@mui/material";
import Grid from "@mui/material/Grid";
import {AnagraficaCompleta} from "../../../../widgets/common/AnagraficaCompleta";
import {BaseStyle} from "../../../../../styles/shared/BaseStyle";
import {AnagraficaContext, AppContext} from "../../../../../App";
import {FormProvider, useForm} from "react-hook-form";
import {getAnagraficaById, resetAnagraficaLoading, updateAnagrafica} from "../../../../../services/AnagraficaServices";
import {getAnaGraficaApi} from "../../../../../services/utils/TicketApiData";
import {setOpenSnackbar} from "../../../../../services/AppServices";
import {getAccountInfo} from "../../../../../utils/GenericUtils";

const AnagraficaDetailSection = ({idSoggetto}) => {
	const classes = BaseStyle();
	const anagraficaContext = useContext(AnagraficaContext);
	const appContext = useContext(AppContext);
	const methods = useForm({mode: "onChange"});
	const [submit, setSubmit] = useState(false);
	const [resetAnagrafica, setResetAnagrafica] = useState(false);

	const onSubmit = useCallback((data) => {
		setSubmit(true);
		updateAnagrafica(getAnaGraficaApi({
			...anagraficaContext.state.anagrafica, ...data
		}), idSoggetto, anagraficaContext.dispatch);
	}, [idSoggetto, anagraficaContext.state.anagrafica, anagraficaContext.dispatch])

	useEffect(() => {
		getAnagraficaById(idSoggetto, anagraficaContext.dispatch)
	}, [idSoggetto, anagraficaContext.dispatch])

	useEffect(() => {
		if (!resetAnagrafica && !anagraficaContext.state.loadingGetAnagrafica && anagraficaContext.state.errorGetAnagrafica === "") {
			methods.reset(anagraficaContext.state.anagrafica);
			setResetAnagrafica(true);
			resetAnagraficaLoading(anagraficaContext.dispatch)
		}
	}, [anagraficaContext.state.anagrafica, anagraficaContext.state.loadingGetAnagrafica, anagraficaContext.state.errorGetAnagrafica,
		methods, resetAnagrafica, anagraficaContext.dispatch])

	useEffect(() => {
		if (submit && !anagraficaContext.state.loadingUpdateAnagrafica && anagraficaContext.state.errorUpdateAnagrafica === "") {
			setSubmit(false);
			setOpenSnackbar("success", "Anagrafica aggiornata correttamente", appContext.dispatch);
		} else if (submit && !anagraficaContext.state.loadingUpdateAnagrafica && anagraficaContext.state.errorUpdateAnagrafica !== "") {
			setSubmit(false);
			setOpenSnackbar("error", anagraficaContext.state.errorUpdateAnagrafica, appContext.dispatch);
		}
	}, [submit, anagraficaContext.state.loadingUpdateAnagrafica, anagraficaContext.state.errorUpdateAnagrafica, appContext.dispatch])


	return (
		<React.Fragment>
			<FormProvider {...methods}>
				<form onSubmit={methods.handleSubmit(onSubmit)}>
					<Card className={clsx(classes.roundBorder)}>
						<CardHeader
							title={<Typography variant={"h6"}>
								<b>Anagrafica</b>
							</Typography>}
						/>
						<CardContent style={{flexGrow: 1}}>
							<Grid container spacing={3}>
								{
									anagraficaContext.state.errorGetAnagrafica !== "" ? "Err" :
										<AnagraficaCompleta classes={classes} intro={"false"}
										                    moreInfo={true} anagrafica={anagraficaContext.state.anagrafica}/>
								}
							</Grid>
						</CardContent>
						<CardActions className={classes.flexRight}>
							<Tooltip title={"Aggiorna anagrafica"}>
								<Button variant={"contained"} disableElevation className={classes.roundButton}
								        style={{borderRadius: 24}} disabled={getAccountInfo().roles?.includes("ROLE_SP_301_H")}
								        size={"small"} color={"primary"} onClick={methods.handleSubmit(onSubmit)}>
									<b>Aggiorna anagrafica</b>
								</Button>
							</Tooltip>
						</CardActions>
					</Card>
				</form>
			</FormProvider>
		</React.Fragment>
	);
}

export default React.memo(AnagraficaDetailSection);
